// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Cn from "../../../../node_modules/rescript-classnames/lib/es6_global/src/Cn.bs.js";
import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Js_dict from "../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Caml_obj from "../../../../node_modules/rescript/lib/es6/caml_obj.js";
import * as Belt_Array from "../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Caml_int32 from "../../../../node_modules/rescript/lib/es6/caml_int32.js";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as CSS$Showside from "../utils/CSS.bs.js";
import * as Belt_SortArray from "../../../../node_modules/rescript/lib/es6/belt_SortArray.js";
import * as Stack$Showside from "../utils/Stack.bs.js";
import * as UseSafeTimeout from "../../../../node_modules/@makerinc/use-safe-timeout/lib/es6_global/src/UseSafeTimeout.bs.js";
import * as UseApi$Showside from "../hook/UseApi.bs.js";
import * as Product$Showside from "../types/Product.bs.js";
import * as Category$Showside from "../types/Category.bs.js";
import * as IconDown$Showside from "../icons/IconDown.bs.js";
import * as SmartImg$Showside from "../utils/SmartImg.bs.js";
import * as IconClose$Showside from "../icons/IconClose.bs.js";
import * as Namespace$Showside from "../types/Namespace.bs.js";
import Debounce from "lodash-es/debounce";
import * as QuickViewT$Showside from "../types/QuickViewT.bs.js";
import * as Scrollable$Showside from "./Scrollable.bs.js";
import * as DrawerState$Showside from "../context/DrawerState.bs.js";
import * as ImageSlider$Showside from "./ImageSlider.bs.js";
import * as LocalStorage$Showside from "../utils/LocalStorage.bs.js";
import * as MobileNavbar$Showside from "./MobileNavbar.bs.js";
import * as ProductPrice$Showside from "./ProductPrice.bs.js";
import * as DataAttribute$Showside from "../utils/DataAttribute.bs.js";
import * as ProductBadges$Showside from "./ProductBadges.bs.js";
import * as ReactDOMUtils$Showside from "../utils/ReactDOMUtils.bs.js";
import * as StoreProvider$Showside from "../context/StoreProvider.bs.js";
import * as LocationConfig$Showside from "../utils/LocationConfig.bs.js";
import * as ProductReviews$Showside from "./ProductReviews.bs.js";
import * as RouterProvider$Showside from "../context/RouterProvider.bs.js";
import * as ViewportContext$Showside from "../context/ViewportContext.bs.js";
import * as PDPContentHeader$Showside from "./PDPContentHeader.bs.js";
import * as ConditionalRender$Showside from "../utils/ConditionalRender.bs.js";
import * as EntrypointContext$Showside from "../context/EntrypointContext.bs.js";
import * as PDPContentDetails$Showside from "./PDPContentDetails.bs.js";
import * as ProductRulesConfig$Showside from "../types/ProductRulesConfig.bs.js";
import * as ConfigurationProvider$Showside from "../context/ConfigurationProvider.bs.js";
import * as PhotoSliderThumbnails$Showside from "./PhotoSliderThumbnails.bs.js";
import * as UserSavedProductsContent$Showside from "./UserSavedProductsContent.bs.js";
import * as StickyHeaderOffsetProvider$Showside from "../context/StickyHeaderOffsetProvider.bs.js";
function PDPContentMobile$ColorVariants(Props) {
  var product = Props.product;
  var selectedVariant = Props.selectedVariant;
  var match = RouterProvider$Showside.useRouter(undefined);
  var goTo = match.goTo;
  var route = match.route;
  var match$1 = React.useState(function () {
    return false;
  });
  var setShow = match$1[1];
  var show = match$1[0];
  var handleStackClick = function (e) {
    e.preventDefault();
    e.stopPropagation();
    Curry._1(setShow, function (show) {
      return !show;
    });
  };
  var getColorVariant = function (color) {
    return Belt_Array.getBy(Product$Showside.getAllVariants(product), function (v) {
      return Caml_obj.equal(color, Product$Showside.Variant.getOptionValue(v, "Color"));
    });
  };
  var colors = Belt_Array.keepMap(Belt_Array.keepMap(Product$Showside.getOptionsByName(product, "Color"), function (color) {
    return getColorVariant(color.value);
  }), function (item) {
    var media = item.media;
    var color = Product$Showside.Variant.getOptionValue(item, "Color");
    var image;
    switch (media.TAG | 0) {
      case /* Image */0:
        image = media._0.url;
        break;
      case /* Video */1:
        image = Belt_Option.map(Product$Showside.getVideoSource(media._0), function (source) {
          return source.url;
        });
        break;
      case /* IframeEmbed */2:
        image = undefined;
        break;
    }
    if (color !== undefined && image !== undefined) {
      return [color, image];
    }
  });
  var renderColorForStack = function (titleOpt, linkOpt, color, image, width, height, param) {
    var title = titleOpt !== undefined ? titleOpt : false;
    var link = linkOpt !== undefined ? linkOpt : false;
    var containerWidth = title ? width + 12 | 0 : width;
    return React.createElement(DataAttribute$Showside.make, {
      dataTestId: "pdp-button-color",
      children: React.createElement("div", {
        className: CSS$Showside.prefix(Cn.make(["bg-white relative border-px border-white border-solid", title ? "p-2" : ""])),
        style: {
          width: String(containerWidth) + "px"
        },
        onClick: function (param) {
          var variant = getColorVariant(color);
          if (typeof route === "number" || !(route.TAG === /* PDP */2 && variant !== undefined && link)) {
            return;
          } else {
            return Curry._3(goTo, undefined, true, {
              TAG: /* PDP */2,
              _0: {
                categoryId: route._0.categoryId,
                productCategoryId: product.categoryId,
                productId: product.id,
                variantId: variant.id,
                zoomedPhotoIndex: undefined
              }
            });
          }
        }
      }, React.createElement(SmartImg$Showside.Sized.make, {
        src: image,
        containerWidth: width,
        containerHeight: height,
        fit: /* Cover */1,
        priority: 0
      }), title ? React.createElement("div", {
        className: CSS$Showside.prefix("text-center text-lg text-black py-2")
      }, color) : null)
    });
  };
  if (colors.length <= 1) {
    return null;
  } else {
    return React.createElement(React.Fragment, undefined, React.createElement("div", {
      className: CSS$Showside.prefix("absolute right-0 pr-5"),
      style: {
        bottom: "66px",
        width: "68px"
      }
    }, show ? null : React.createElement("div", {
      className: CSS$Showside.prefix("absolute"),
      style: {
        top: "-58px"
      }
    }, React.createElement(Stack$Showside.make, {
      maxThumbnails: 3,
      items: Belt_Array.map(Belt_SortArray.stableSortBy(colors, function (param, b) {
        if (Caml_obj.equal(param[0], Product$Showside.Variant.getOptionValue(selectedVariant, "Color"))) {
          return -1;
        } else {
          return 1;
        }
      }), function (param) {
        var image = param[1];
        var color = param[0];
        return [color, function (param) {
          return renderColorForStack(undefined, undefined, color, image, 33, 33, param);
        }, function (param) {
          Curry._1(setShow, function (show) {
            return !show;
          });
        }];
      }),
      direction: /* Fan */2,
      width: 33,
      height: 33
    })), React.createElement("div", {
      className: CSS$Showside.prefix("text-white font-medium text-center text-lg drop-shadow"),
      onClick: handleStackClick
    }, "More Colors")), show ? React.createElement("div", {
      className: CSS$Showside.prefix("fixed inset-0"),
      style: {
        zIndex: "2147483647"
      },
      onClick: handleStackClick
    }, React.createElement("div", {
      className: CSS$Showside.prefix("absolute right-0 overflow-x-auto flex gap-2 pr-2 pb-2"),
      style: {
        bottom: "108px",
        maxWidth: "calc(100vw - 82px)"
      },
      onTouchEnd: function (e) {
        e.stopPropagation();
      },
      onTouchMove: function (e) {
        e.stopPropagation();
      },
      onTouchStart: function (e) {
        e.stopPropagation();
      }
    }, Belt_Array.map(colors, function (param) {
      return renderColorForStack(true, true, param[0], param[1], 90, 90, undefined);
    }))) : null);
  }
}
PDPContentMobile$ColorVariants.displayName = "PDPContentMobile.ColorVariants";
var ColorVariants = {
  make: PDPContentMobile$ColorVariants
};
function PDPContentMobile$ProductSlide(Props) {
  var product = Props.product;
  var selectedVariant = Props.selectedVariant;
  var settings = Props.settings;
  var productPositionOpt = Props.productPosition;
  var productsCountOpt = Props.productsCount;
  var productCategory = Props.productCategory;
  var scrollToDetails = Props.scrollToDetails;
  var selectedSlideOpt = Props.selectedSlide;
  var visibleOpt = Props.visible;
  var productPosition = productPositionOpt !== undefined ? productPositionOpt : 0;
  var productsCount = productsCountOpt !== undefined ? productsCountOpt : 0;
  var selectedSlide = selectedSlideOpt !== undefined ? selectedSlideOpt : true;
  var visible = visibleOpt !== undefined ? visibleOpt : true;
  var store = StoreProvider$Showside.use(undefined);
  var match = RouterProvider$Showside.useRouter(undefined);
  var listPageType = match.listPageType;
  var match$1 = EntrypointContext$Showside.use(undefined);
  var onBackClick = match$1.onBackClick;
  var onOpenLink = match$1.onOpenLink;
  var match$2 = LocationConfig$Showside.use(undefined);
  var match$3 = ConfigurationProvider$Showside.use(undefined);
  var config = match$3.config;
  var isAltFunnel = Caml_obj.equal(Belt_Option.map(match$2.namespace, Namespace$Showside.toString), "alt");
  var selectedVariant$1 = selectedVariant !== undefined ? selectedVariant : product.firstVariant;
  var hideAddToCartButton = Belt_Option.mapWithDefault(Belt_Option.flatMap(config.transitiveAccount, function (account) {
    return account.productRules.hideAddToCartButton;
  }), false, function (rule) {
    return ProductRulesConfig$Showside.matchesProduct(rule, product, selectedVariant$1);
  });
  var match$4 = React.useState(function () {
    return 0;
  });
  var setCurrentSlide = match$4[1];
  var currentSlide = match$4[0];
  var handleChange = function (value) {
    Curry._1(setCurrentSlide, function (param) {
      return value;
    });
  };
  React.useEffect(function () {
    Curry._1(setCurrentSlide, function (param) {
      return 0;
    });
  }, [selectedVariant$1.id]);
  var hideMediaFromOtherVariants = Belt_Option.mapWithDefault(config.transitiveAccount, false, function (account) {
    return account.pdpHideMediaFromOtherVariants;
  });
  var medias = React.useMemo(function () {
    return Product$Showside.getAllVariantMedia(hideMediaFromOtherVariants, product, selectedVariant$1);
  }, [selectedVariant$1.id, product.id]);
  var title;
  if (listPageType !== undefined && typeof listPageType === "number") {
    switch (listPageType) {
      case /* Favorites */0:
        title = "Favorites";
        break;
      case /* History */1:
        title = "Recently Viewed";
        break;
      case /* StoreCart */2:
        title = productCategory.title;
        break;
    }
  } else {
    title = productCategory.title;
  }
  var renderOpenLinkButton = function (param) {
    return React.createElement("button", {
      className: CSS$Showside.prefix(Cn.make(["flex items-center justify-center flex-col bg-white", "text-lg text-center text-black font-semibold drop-shadow-sm cursor-pointer"])),
      style: {
        height: "46px",
        lineHeight: "46px",
        maxWidth: "calc(100vw - (54px + 28px) * 2)",
        width: "250px"
      },
      onClick: function (param) {
        Curry._5(onOpenLink, productCategory, undefined, product, selectedVariant$1, undefined);
      }
    }, settings.pdpOpenLinkLabel);
  };
  var renderBuyNowButton = function (param) {
    return React.createElement("button", {
      className: CSS$Showside.prefix(Cn.make(["flex items-center justify-center flex-col bg-white", "text-lg text-center text-black font-semibold drop-shadow-sm cursor-pointer"])),
      style: {
        height: "46px",
        lineHeight: "46px",
        maxWidth: "calc(100vw - (54px + 28px) * 2)",
        width: "250px"
      },
      onClick: function (param) {
        Curry._1(scrollToDetails, undefined);
      }
    }, "Buy Now");
  };
  var summary = product.reviewSummary;
  var match$5 = settings.pdpCTAButtons;
  var match$6 = match$5[0];
  var tmp;
  if (match$6 === "open_link") {
    tmp = renderOpenLinkButton(undefined);
  } else if (match$6 === "add_to_cart") {
    var match$7 = match$5[1];
    tmp = match$7 !== undefined && match$7 === "open_link" && hideAddToCartButton ? renderOpenLinkButton(undefined) : renderBuyNowButton(undefined);
  } else {
    tmp = renderBuyNowButton(undefined);
  }
  var tmp$1;
  if (medias.length > 1) {
    var bottom = medias.length <= 3 ? 58 : 62;
    tmp$1 = React.createElement("div", {
      className: CSS$Showside.prefix("absolute left-0 pl-5"),
      style: {
        bottom: String(bottom) + "px"
      }
    }, React.createElement(PhotoSliderThumbnails$Showside.make, {
      medias: medias,
      currentSlide: currentSlide,
      setSlideToIndex: setCurrentSlide,
      onClickThumbnail: function (param) {},
      maxSlidesPerViewport: 3.2,
      product: product,
      variantId: selectedVariant$1.id
    }));
  } else {
    tmp$1 = null;
  }
  return React.createElement("div", {
    className: CSS$Showside.prefix("absolute inset-0 bg-main no-flicker")
  }, React.createElement(ImageSlider$Showside.make, {
    product: product,
    selectedVariant: selectedVariant$1,
    settings: settings,
    selectedSlide: selectedSlide,
    visible: visible,
    onChange: handleChange,
    currentSlide: currentSlide
  }), React.createElement("div", {
    className: CSS$Showside.prefix("absolute w-full top-10 left-0 px-6 no-flicker text-white")
  }, React.createElement("div", {
    className: CSS$Showside.prefix("grid grid-cols-12 grid-rows-1 gap-1 justify-between items-start")
  }, React.createElement("div", {
    className: CSS$Showside.prefix("text-white flex items-start col-span-11")
  }, title + " " + String(productPosition) + "/" + String(productsCount)), isAltFunnel || match$1.embedType === /* ProductDetailsPage */5 ? null : React.createElement(DataAttribute$Showside.make, {
    dataTestId: "pdp-button-open-close",
    children: React.createElement("button", {
      className: CSS$Showside.prefix(Cn.make(["absolute -top-4 right-1", "border-none bg-transparent", "w-14 h-14", "text-white flex items-center justify-center"])),
      onClick: function (param) {
        Curry._1(onBackClick, undefined);
      }
    }, React.createElement(IconClose$Showside.make, {
      className: CSS$Showside.prefix("cursor-pointer")
    }))
  })), React.createElement("div", {
    className: CSS$Showside.prefix("flex gap-2 justify-between items-start")
  }, React.createElement("div", undefined, React.createElement(ProductBadges$Showside.make, {
    className: CSS$Showside.prefix("mt-2"),
    dataTestId: "pdp-product-badges",
    product: product,
    variant: selectedVariant$1
  }), React.createElement(DataAttribute$Showside.make, {
    dataTestId: "pdp-product-title",
    children: React.createElement("h1", {
      className: CSS$Showside.prefix("text-xl font-bold drop-shadow-sm text-white mt-3 mb-1")
    }, Product$Showside.getDisplayName(store, selectedVariant$1, product))
  }), React.createElement(ProductPrice$Showside.make, {
    at: /* PDP */0,
    product: product,
    variant: selectedVariant$1,
    size: /* Md */1,
    labelsEnabled: false,
    minPriceFirst: true,
    multiline: false,
    textColor: "text-white"
  })), summary !== undefined ? React.createElement(ProductReviews$Showside.make, {
    at: /* PDP */0,
    product: product,
    variant: selectedVariant$1,
    className: CSS$Showside.prefix("mt-4"),
    countClassName: CSS$Showside.prefix("text-white"),
    largeCount: true
  }) : null)), React.createElement("div", {
    className: CSS$Showside.prefix(Cn.make(["absolute bottom-0 left-0 pb-3 w-full", "flex items-center justify-center flex-col gap-6", "no-flicker"]))
  }, React.createElement(DataAttribute$Showside.make, {
    dataTestId: "pdp-button-buy-now",
    children: tmp
  }), React.createElement(DataAttribute$Showside.make, {
    dataTestId: "pdp-button-product-details",
    children: React.createElement("button", {
      className: CSS$Showside.prefix(Cn.make(["border-none bg-transparent", "flex items-center justify-center flex-col", "text-lg text-center text-white font-semibold drop-shadow-sm cursor-pointer"])),
      onClick: function (param) {
        Curry._1(scrollToDetails, undefined);
      }
    }, React.createElement("span", {
      className: CSS$Showside.prefix("text-white")
    }, "Product Details"), React.createElement(IconDown$Showside.make, {}))
  })), tmp$1, React.createElement(PDPContentMobile$ColorVariants, {
    product: product,
    selectedVariant: selectedVariant$1
  }));
}
PDPContentMobile$ProductSlide.displayName = "PDPContentMobile.ProductSlide";
var ProductSlide = {
  make: PDPContentMobile$ProductSlide
};
function PDPContentMobile$ProductDetails(Props) {
  var product = Props.product;
  var variant = Props.variant;
  var settings = Props.settings;
  var isInsideQuickView = Props.isInsideQuickView;
  var productCategory = Props.productCategory;
  var shouldForceMobile = Props.shouldForceMobile;
  var viewport = Props.viewport;
  var scrollableContainerRef = Props.scrollableContainerRef;
  var scrollToDetails = Props.scrollToDetails;
  var scrollPosition = Props.scrollPosition;
  var windowHeight = Props.windowHeight;
  var onProductClick = Props.onProductClick;
  var quantity = Props.quantity;
  var setQuantity = Props.setQuantity;
  var showMoreProducts = Props.showMoreProducts;
  var scrollToDetailsRef = React.useRef(scrollToDetails);
  var match = React.useState(function () {
    return /* Visible */3;
  });
  var setCtaVisible = match[1];
  var handleCTAVisibilityChange = function (visibility) {
    Curry._1(setCtaVisible, function (param) {
      if (visibility === /* Visible */3 || scrollPosition === /* Top */0 || scrollPosition === /* Scrolled */1) {
        return /* Visible */3;
      } else {
        return visibility;
      }
    });
  };
  var tmp = {
    product: product,
    variant: variant,
    productCategory: productCategory,
    shouldForceMobile: shouldForceMobile,
    isInsideQuickView: isInsideQuickView,
    viewport: viewport,
    scrollableContainerRef: scrollableContainerRef,
    scrollToDetailsRef: scrollToDetailsRef,
    showHeader: false,
    collapsible: false,
    titleStyle: "normal",
    largeTitleStyle: "medium",
    optionSize: /* Md */2,
    optionStyle: /* Border */0,
    colorOptionSize: /* Xxl */5,
    hideRelatedProductId: product.id,
    showRelatedProducts: scrollPosition === /* Details */2,
    descriptionLayout: /* Accordion */1,
    onCTAButtonVisibilityChange: handleCTAVisibilityChange,
    onProductClick: onProductClick,
    quantity: quantity,
    setQuantity: setQuantity,
    stickyCTA: false
  };
  if (showMoreProducts !== undefined) {
    tmp.showMoreProducts = Caml_option.valFromOption(showMoreProducts);
  }
  return React.createElement(React.Fragment, undefined, React.createElement(PDPContentHeader$Showside.make, {
    product: product,
    variant: variant,
    settings: settings,
    scrollToDetails: scrollToDetails,
    scrollableContainerRef: scrollableContainerRef,
    position: /* StickyTop */1,
    showCTA: match[0] === /* HiddenBottom */1,
    quantity: quantity,
    setQuantity: setQuantity
  }), React.createElement(ConditionalRender$Showside.Delayed.make, {
    delayMs: 300,
    children: React.createElement("div", {
      className: CSS$Showside.prefix("mt-6"),
      style: {
        marginBottom: "48px",
        minHeight: String(windowHeight - (PDPContentHeader$Showside.stickyHeight - 22 | 0) | 0) + "px"
      }
    }, React.createElement(PDPContentDetails$Showside.make, tmp))
  }));
}
PDPContentMobile$ProductDetails.displayName = "PDPContentMobile.ProductDetails";
var ProductDetails = {
  make: PDPContentMobile$ProductDetails
};
function useCategoryProducts(category, settings, product) {
  var match = RouterProvider$Showside.useRouter(undefined);
  var relatedProductId = match.relatedProductId;
  var listPageType = match.listPageType;
  var match$1 = ConfigurationProvider$Showside.use(undefined).config;
  var account = match$1.transitiveAccount;
  var storeId = match$1.transitiveStoreId;
  var match$2 = Category$Showside.ExternalConnection.getConnection(category);
  var listPageType$1;
  if (match$2 !== undefined && typeof match$2 === "number") {
    switch (match$2) {
      case /* History */0:
        listPageType$1 = /* History */1;
        break;
      case /* Favorites */1:
        listPageType$1 = /* Favorites */0;
        break;
      case /* StoreCart */2:
        listPageType$1 = /* StoreCart */2;
        break;
    }
  } else {
    listPageType$1 = listPageType;
  }
  var defaultFilters = Belt_Option.flatMap(Category$Showside.ExternalConnection.getStoreCategoryConnection(category), function (connection) {
    return Category$Showside.ExternalConnection.getFilterBy(connection, account);
  });
  var match$3 = EntrypointContext$Showside.use(undefined);
  var market = match$3.market;
  var smartnavApiHost = match$3.smartnavApiHost;
  var match$4 = UseApi$Showside.useCategoryProducts(storeId, category.id, Category$Showside.ExternalConnection.getStoreCategoryConnection(category), settings.hideOutOfStock, undefined, defaultFilters, 10, match.productSort, true, smartnavApiHost, market, undefined);
  var total = match$4.total;
  var match$5 = UseApi$Showside.useProductsById(storeId, Category$Showside.getProductIds(category), settings.hideOutOfStock, true, category.id, smartnavApiHost, market, undefined);
  var featuredProducts = Belt_Option.getWithDefault(match$5.products, []);
  var match$6 = UseApi$Showside.useRelatedProducts(relatedProductId, storeId, "", settings.hideOutOfStock, relatedProductId !== undefined, smartnavApiHost, market, undefined);
  var match$7 = UserSavedProductsContent$Showside.useUserSavedProducts(settings.hideOutOfStock, Caml_obj.equal(listPageType$1, /* History */1), true, undefined, "history");
  var historyProducts = match$7.products;
  var match$8 = UserSavedProductsContent$Showside.useUserSavedProducts(settings.hideOutOfStock, Caml_obj.equal(listPageType$1, /* Favorites */0), true, undefined, "favorites");
  var favoriteProducts = match$8.products;
  var match$9 = UserSavedProductsContent$Showside.useUserSavedProducts(settings.hideOutOfStock, Caml_obj.equal(listPageType$1, /* StoreCart */2), true, undefined, "cart");
  var cartProducts = match$9.products;
  var match$10;
  var exit = 0;
  if (listPageType$1 !== undefined && typeof listPageType$1 === "number") {
    switch (listPageType$1) {
      case /* Favorites */0:
        match$10 = [Belt_Option.getWithDefault(favoriteProducts, []), Belt_Option.isSome(favoriteProducts), 1, 1, function (param) {}];
        break;
      case /* History */1:
        match$10 = [Belt_Option.getWithDefault(historyProducts, []), Belt_Option.isSome(historyProducts), 1, 1, function (param) {}];
        break;
      case /* StoreCart */2:
        match$10 = [Belt_Option.getWithDefault(cartProducts, []), Belt_Option.isSome(cartProducts), 1, 1, function (param) {}];
        break;
    }
  } else {
    exit = 1;
  }
  if (exit === 1) {
    match$10 = relatedProductId !== undefined ? [Belt_Option.getWithDefault(match$6.products, []), match$6.reachedEnd, match$6.numPages, match$6.numLoadedPages, match$6.setNumPages] : [Belt_Option.getWithDefault(match$4.products, []), match$4.reachedEnd, match$4.numPages, match$4.numLoadedPages, match$4.setNumPages];
  }
  var setNumPages = match$10[4];
  var numLoadedPages = match$10[3];
  var numPages = match$10[2];
  var reachedEnd = match$10[1];
  var featureProductsIds = Belt_Array.map(featuredProducts, function (product) {
    return product.id;
  });
  var connectedProducts = Belt_Array.keep(match$10[0], function (product) {
    return Belt_Array.some(featureProductsIds, function (id) {
      return id === product.id;
    }) === false;
  });
  var products = Belt_Array.concatMany([featuredProducts, connectedProducts]);
  var loadedProductsCount = products.length;
  var productPosition = Belt_Array.getIndexBy(products, function (p) {
    return p.id === product.id;
  });
  var count;
  var exit$1 = 0;
  var exit$2 = 0;
  if (listPageType$1 !== undefined && typeof listPageType$1 === "number") {
    switch (listPageType$1) {
      case /* Favorites */0:
        count = Js_dict.entries(match$8.idDict).length;
        break;
      case /* History */1:
        count = Js_dict.entries(match$7.idDict).length;
        break;
      case /* StoreCart */2:
        count = Js_dict.entries(match$9.idDict).length;
        break;
    }
  } else {
    exit$2 = 2;
  }
  if (exit$2 === 2) {
    if (total !== undefined && total > 0) {
      count = total;
    } else {
      exit$1 = 1;
    }
  }
  if (exit$1 === 1) {
    count = Belt_Option.mapWithDefault(Category$Showside.ExternalConnection.getStoreCategoryConnection(category), 0, function (connection) {
      return connection.count;
    }) + featureProductsIds.length | 0;
  }
  React.useEffect(function () {
    var match = numLoadedPages >= numPages;
    if (productPosition !== undefined) {
      if (match && !(reachedEnd || (productPosition + 1 | 0) !== loadedProductsCount)) {
        Curry._1(setNumPages, numPages + 1 | 0);
      }
    } else if (match && !reachedEnd) {
      Curry._1(setNumPages, numPages + 1 | 0);
    }
  }, [productPosition, numPages, numLoadedPages, loadedProductsCount, reachedEnd]);
  if (productPosition !== undefined) {
    return [productPosition, count, products];
  } else {
    return [0, 1, [product]];
  }
}
function useProductPosition(config, category, settings, productId, product) {
  var match = RouterProvider$Showside.useRouter(undefined);
  var match$1 = RouterProvider$Showside.useRouter(undefined);
  var match$2 = useCategoryProducts(category, settings, product);
  var products = match$2[2];
  var count = match$2[1];
  var productPosition = match$2[0];
  var match$3 = match$1.raw.quickView.mediaId;
  var media = config !== undefined && match$3 !== undefined ? QuickViewT$Showside.mediaById(config, match$3) : undefined;
  var match$4;
  if (match.isQuickView && media !== undefined && config !== undefined) {
    var products$1 = Belt_Array.reduce(Curry._2(QuickViewT$Showside.productsInMedia, config, media), [], function (acc, curr) {
      var found = Belt_Array.some(acc, function (media) {
        return media.id === curr.id;
      });
      if (found) {
        return acc;
      } else {
        return Belt_Array.concat(acc, [curr]);
      }
    });
    var count$1 = products$1.length;
    var productPosition$1 = Belt_Array.getIndexBy(products$1, function (p) {
      return Caml_obj.equal(p.id, productId);
    });
    match$4 = productPosition$1 !== undefined ? [productPosition$1, count$1, products$1] : [count$1, count$1 + 1 | 0, Belt_Array.concat(products$1, [product])];
  } else {
    match$4 = [productPosition, count, products];
  }
  return [match$4[0], match$4[1], match$4[2]];
}
function PDPContentMobile$Slider(Props) {
  var selectedSlideOpt = Props.selectedSlide;
  var windowHeight = Props.windowHeight;
  var goToSlide = Props.goToSlide;
  var children = Props.children;
  var preventScroll = Props.preventScroll;
  var animationOpt = Props.animation;
  var animateOpt = Props.animate;
  var showIntroAnimationOpt = Props.showIntroAnimation;
  var selectedSlide = selectedSlideOpt !== undefined ? selectedSlideOpt : 0;
  var animation = animationOpt !== undefined ? animationOpt : /* Slide */0;
  var animate = animateOpt !== undefined ? animateOpt : true;
  var showIntroAnimation = showIntroAnimationOpt !== undefined ? showIntroAnimationOpt : false;
  var match = ViewportContext$Showside.use(undefined);
  var windowWidth = match.windowSize.width;
  var match$1 = React.useState(function () {
    return selectedSlide;
  });
  var setInternalSelectedSlide = match$1[1];
  var internalSelectedSlide = match$1[0];
  React.useEffect(function () {
    Curry._1(setInternalSelectedSlide, function (param) {
      return selectedSlide;
    });
  }, [selectedSlide]);
  var match$2 = React.useState(function () {
    return /* NotSwiping */0;
  });
  var setSwipe = match$2[1];
  var swipe = match$2[0];
  var handleMouseDown = function ($$event) {
    var x = $$event.clientX;
    var y = $$event.clientY;
    Curry._1(setSwipe, function (param) {
      return /* Swiping */{
        _0: x,
        _1: y,
        _2: 0
      };
    });
  };
  var handleTouchDown = function ($$event) {
    var x = $$event.touches[0].clientX;
    var y = $$event.touches[0].clientY;
    Curry._1(setSwipe, function (param) {
      return /* Swiping */{
        _0: x,
        _1: y,
        _2: 0
      };
    });
  };
  var handleMove = function (positionX, positionY) {
    if (!swipe) {
      return;
    }
    var y = swipe._1;
    var x = swipe._0;
    var diffX = x - positionX | 0;
    var diffY = y - positionY | 0;
    var isSignificantMovement = (Math.imul(diffX, diffX) + Math.imul(diffY, diffY) | 0) >= 25;
    var touchAngle = Math.atan2(Math.abs(diffY), Math.abs(diffX)) * 180.0 / Math.PI;
    var edgeSwipe = x < 20 || (windowWidth - x | 0) < 20;
    var reachedEnd = internalSelectedSlide === (children.length - 1 | 0);
    var match = touchAngle < 45;
    if (isSignificantMovement) {
      if (match) {
        if (!edgeSwipe) {
          if (diffX > 0 && !reachedEnd) {
            return Curry._1(setSwipe, function (param) {
              return /* Swiping */{
                _0: x,
                _1: y,
                _2: diffX
              };
            });
          } else if (diffX < 0 && internalSelectedSlide !== 0) {
            return Curry._1(setSwipe, function (param) {
              return /* Swiping */{
                _0: x,
                _1: y,
                _2: diffX
              };
            });
          } else {
            return;
          }
        }
        if (!edgeSwipe) {
          return;
        }
      }
    } else if (!edgeSwipe) {
      return;
    }
    Curry._1(setSwipe, function (param) {
      return /* NotSwiping */0;
    });
  };
  var handleMouseMove = function ($$event) {
    handleMove($$event.clientX, $$event.clientY);
  };
  var handleTouchMove = function ($$event) {
    handleMove($$event.touches[0].clientX, $$event.touches[0].clientY);
  };
  var handleMouseUp = function (e) {
    if (!swipe) {
      return;
    }
    var diff = swipe._2;
    var nextSlide = diff < -10 ? internalSelectedSlide - 1 | 0 : diff > 10 ? internalSelectedSlide + 1 | 0 : undefined;
    if (nextSlide !== undefined) {
      Curry._1(setInternalSelectedSlide, function (param) {
        return nextSlide;
      });
      Curry._1(goToSlide, nextSlide);
    }
    Curry._1(setSwipe, function (param) {
      return /* NotSwiping */0;
    });
    Curry._1(preventScroll, false);
  };
  var match$3;
  if (animation) {
    var transformZ = windowWidth / 2;
    var rotate = Math.imul(internalSelectedSlide, 90);
    var exit = 0;
    if (swipe) {
      var diff = swipe._2;
      if (diff > 10 || diff < -10) {
        var rotate$1 = rotate + (diff / windowWidth * 90 | 0) | 0;
        match$3 = [0, transformZ, rotate$1, ""];
      } else {
        exit = 1;
      }
    } else {
      exit = 1;
    }
    if (exit === 1) {
      match$3 = animate ? [0, transformZ, rotate, "transform 0.3s"] : [0, transformZ, rotate, ""];
    }
  } else {
    var transformX = Math.imul(internalSelectedSlide, windowWidth);
    var exit$1 = 0;
    if (swipe) {
      var diff$1 = swipe._2;
      if (diff$1 > 10 || diff$1 < -10) {
        var transformX$1 = transformX + diff$1 | 0;
        match$3 = [transformX$1, 0, 0, ""];
      } else {
        exit$1 = 1;
      }
    } else {
      exit$1 = 1;
    }
    if (exit$1 === 1) {
      match$3 = animate ? [transformX, 0, 0, "left 0.3s"] : [transformX, 0, 0, ""];
    }
  }
  var rotate$2 = match$3[2];
  var transformZ$1 = match$3[1];
  var transformX$2 = match$3[0];
  var left = animation ? "0" : "-" + String(transformX$2) + "px";
  var transform = animation ? "translateZ(-" + String(transformZ$1) + "px) rotateY(-" + String(rotate$2) + "deg)" : "";
  var perspective = animation ? "600px" : "";
  var transformStyle = animation ? "preserve-3d" : "";
  React.useEffect(function () {
    if (animation) {
      Curry._1(preventScroll, rotate$2 % 90 !== 0);
    } else {
      Curry._1(preventScroll, Caml_int32.mod_(transformX$2, windowWidth) !== 0);
    }
  }, [animation, transformX$2, rotate$2]);
  return React.createElement("div", {
    className: CSS$Showside.prefix(Cn.make(["w-full h-full bg-black", showIntroAnimation ? "animate-nudge-left" : ""])),
    style: {
      height: String(windowHeight) + "px",
      perspective: perspective
    },
    onMouseDown: handleMouseDown,
    onMouseMove: handleMouseMove,
    onMouseUp: handleMouseUp,
    onTouchEnd: handleMouseUp,
    onTouchMove: handleTouchMove,
    onTouchStart: handleTouchDown
  }, React.createElement("style", undefined, "\n      .QVTW__pdp-slider {\n        --pdp-slider-left: " + left + ";\n        --pdp-slider-transform: " + transform + ";\n        --pdp-slider-transform-style: " + transformStyle + ";\n        --pdp-slider-transition: " + match$3[3] + ";\n        --pdp-slider-width: " + (animation ? "100%" : String(Math.imul(windowWidth, children.length))) + "px;\n      }\n      "), React.createElement("div", {
    className: CSS$Showside.prefix("pdp-slider h-full relative flex"),
    style: {
      left: "var(--pdp-slider-left, 0px)",
      width: "var(--pdp-slider-width, 0px)",
      transition: "var(--pdp-slider-transition, initial)",
      transform: "var(--pdp-slider-transform, initial)",
      transformStyle: "var(--pdp-slider-transform-style, initial)"
    }
  }, Belt_Array.map(Belt_Array.keepMap(Belt_Array.mapWithIndex(children, function (i, param) {
    return [i, param[0], param[1]];
  }), function (param) {
    var id = param[1];
    var i = param[0];
    var visible = Math.abs(i - internalSelectedSlide | 0) <= 1;
    var result = visible ? [i, id, param[2]] : [i, id, null];
    if (animation && !visible) {
      return;
    } else {
      return result;
    }
  }), function (param) {
    var transform = animation ? "rotateY(" + String(Math.imul(param[0], 90)) + "deg) translateZ(" + String(transformZ$1) + "px)" : "";
    return React.createElement("div", {
      key: param[1],
      className: CSS$Showside.prefix(Cn.make(["h-full bg-white", animation ? "absolute" : "relative"])),
      style: {
        width: String(windowWidth) + "px",
        transform: transform
      }
    }, param[2]);
  })));
}
PDPContentMobile$Slider.displayName = "PDPContentMobile.Slider";
var Slider = {
  horizontalThreshold: 10,
  make: PDPContentMobile$Slider
};
function PDPContentMobile(Props) {
  var product = Props.product;
  var variant = Props.variant;
  var productCategory = Props.productCategory;
  var shouldForceMobile = Props.shouldForceMobile;
  var settings = Props.settings;
  var isInsideQuickView = Props.isInsideQuickView;
  var routeProductId = Props.routeProductId;
  var routeVariantId = Props.routeVariantId;
  var viewport = Props.viewport;
  var scrollableContainerRef = Props.scrollableContainerRef;
  var scrollToRef = Props.scrollToRef;
  var config = Props.config;
  var onProductClick = Props.onProductClick;
  var onScroll = Props.onScroll;
  var quantity = Props.quantity;
  var setQuantity = Props.setQuantity;
  var showMoreProducts = Props.showMoreProducts;
  var drawerState = DrawerState$Showside.Provider.use(undefined);
  ConfigurationProvider$Showside.use(undefined);
  var match = RouterProvider$Showside.useRouter(undefined);
  var goTo = match.goTo;
  var route = match.route;
  var match$1 = EntrypointContext$Showside.use(undefined);
  var embedType = match$1.embedType;
  var windowHeight = StickyHeaderOffsetProvider$Showside.useAdjustedWindowHeight(undefined);
  var productDetailsContainerRef = React.useRef(null);
  var productChanged = Caml_obj.notequal(product.id, routeProductId);
  var match$2 = productChanged ? [product.id, undefined] : [routeProductId, routeVariantId];
  var productId = match$2[0];
  var match$3 = useProductPosition(config, productCategory, settings, productId, product);
  var products = match$3[2];
  var productsCount = match$3[1];
  var partial_arg = Debounce(function (position) {
    var nextProduct = Belt_Array.get(products, position);
    if (nextProduct === undefined) {
      return;
    }
    if (typeof route !== "number") {
      switch (route.TAG | 0) {
        case /* PDP */2:
          var match = route._0;
          return Curry._3(goTo, undefined, undefined, {
            TAG: /* PDP */2,
            _0: {
              categoryId: match.categoryId,
              productCategoryId: Belt_Option.orElse(match.productCategoryId, productCategory.id),
              productId: nextProduct.id,
              variantId: undefined,
              zoomedPhotoIndex: undefined
            }
          });
        case /* QuickView */3:
          var match$1 = route._0;
          return Curry._3(goTo, undefined, undefined, {
            TAG: /* QuickView */3,
            _0: {
              mediaId: match$1.mediaId,
              mediaParentId: match$1.mediaParentId,
              albumId: undefined,
              productId: nextProduct.id,
              relatedMediaProductIds: match$1.relatedMediaProductIds,
              relatedMediaCategoryId: match$1.relatedMediaCategoryId,
              variantId: undefined,
              panelClosed: match$1.panelClosed,
              zoomedPhotoIndex: undefined,
              time: undefined
            }
          });
        default:
      }
    }
    Curry._3(goTo, undefined, undefined, {
      TAG: /* PDP */2,
      _0: {
        categoryId: productCategory.id,
        productCategoryId: productCategory.id,
        productId: nextProduct.id,
        variantId: undefined,
        zoomedPhotoIndex: undefined
      }
    });
  }, 500);
  var goToSlide = React.useCallback(Curry.__1(partial_arg), [Belt_Array.joinWith(products, ",", function (p) {
    return p.id;
  }), RouterProvider$Showside.toString(route)]);
  var initializedScroll = React.useRef(false);
  var match$4 = React.useState(function () {
    return false;
  });
  var setPreventScroll = match$4[1];
  var preventScroll = match$4[0];
  var handlePreventScroll = React.useCallback(function (prevent) {
    Curry._1(setPreventScroll, function (param) {
      return prevent;
    });
  }, []);
  var match$5 = UseSafeTimeout.useSafeTimeout(undefined, undefined);
  var setInitializedScrollTimeout = match$5.setTimeout;
  var scrollToDetails = React.useCallback(function (param) {
    initializedScroll.current = true;
    Belt_Option.forEach(Caml_option.nullable_to_opt(productDetailsContainerRef.current), function (el) {
      Curry._1(scrollToRef.current, {
        TAG: /* Element */0,
        _0: el
      });
    });
    setInitializedScrollTimeout(function (param) {
      initializedScroll.current = false;
    }, 250);
  }, [windowHeight]);
  var scrollToTop = React.useCallback(function (param) {
    initializedScroll.current = true;
    Curry._1(scrollToRef.current, {
      TAG: /* Pixel */1,
      _0: 0
    });
    setInitializedScrollTimeout(function (param) {
      initializedScroll.current = false;
    }, 250);
  }, [windowHeight]);
  var match$6 = React.useState(function () {
    return /* Top */0;
  });
  var setScrollPosition = match$6[1];
  var scrollPositionRef = React.useRef(0);
  var touchStateRef = React.useRef(/* Ended */1);
  var getScrollPosition = React.useCallback(function (param) {
    return Belt_Option.mapWithDefault(Belt_Option.map(Caml_option.nullable_to_opt(scrollableContainerRef.current), function (prim) {
      return prim.scrollTop;
    }), 0, function (prim) {
      return prim | 0;
    });
  }, [windowHeight]);
  var snap = React.useCallback(function (param) {
    var top = Curry._1(getScrollPosition, undefined);
    var scrollDiff = top - scrollPositionRef.current | 0;
    var scrollDirection = scrollDiff > 0 ? /* Down */0 : scrollDiff < 0 ? /* Up */1 : /* NotScrolling */2;
    switch (scrollDirection) {
      case /* Down */0:
        if (top > 30 && top < windowHeight) {
          return Curry._1(scrollToDetails, undefined);
        }
        if (top < 30) {
          return Curry._1(scrollToTop, undefined);
        }
        break;
      case /* Up */1:
        if (top < (windowHeight - 30 | 0)) {
          return Curry._1(scrollToTop, undefined);
        }
        break;
      case /* NotScrolling */2:
        break;
    }
    if (top > (windowHeight - 30 | 0) && top < (windowHeight + 30 | 0)) {
      return Curry._1(scrollToDetails, undefined);
    }
  }, [getScrollPosition, scrollToDetails, scrollToTop]);
  var match$7 = React.useState(function () {
    return false;
  });
  var setDetailsVisible = match$7[1];
  var detailsVisible = match$7[0];
  var snapIfNeeded = React.useCallback(function (param) {
    if (touchStateRef.current === /* Ended */1 && initializedScroll.current === false) {
      return Curry._1(snap, undefined);
    }
  }, [snap]);
  var partial_arg$1 = Debounce(function (param) {
    Curry._1(snapIfNeeded, undefined);
  }, 100);
  var debouncedSnapIfNeeded = React.useCallback(Curry.__1(partial_arg$1), [snapIfNeeded]);
  var handleScroll = React.useCallback(function (e) {
    return function (wasAutoScroll) {
      var top = Curry._1(getScrollPosition, undefined);
      Curry._1(setScrollPosition, function (param) {
        if (top < 20) {
          return /* Top */0;
        } else if (top < (windowHeight - 1 | 0)) {
          return /* Scrolled */1;
        } else {
          return /* Details */2;
        }
      });
      Curry._1(setDetailsVisible, function (param) {
        return top >= windowHeight;
      });
      if (top === 0) {
        Curry._2(onScroll, e, wasAutoScroll);
      }
      return Curry._1(debouncedSnapIfNeeded, undefined);
    };
  }, [onScroll, debouncedSnapIfNeeded]);
  var handleTouchStart = React.useCallback(function (e) {
    scrollPositionRef.current = Curry._1(getScrollPosition, undefined);
    touchStateRef.current = /* Started */0;
  }, []);
  var handleTouchEnd = React.useCallback(function (e) {
    touchStateRef.current = /* Ended */1;
    Curry._1(snapIfNeeded, undefined);
    scrollPositionRef.current = Curry._1(getScrollPosition, undefined);
  }, [snapIfNeeded]);
  var renderMobileNavbar = function (param) {
    var shouldRender = drawerState === /* Open */2 || isInsideQuickView;
    var showNavbar = shouldRender && embedType !== /* ProductDetailsPage */5;
    if (showNavbar) {
      return React.createElement(MobileNavbar$Showside.make, {
        position: /* Fixed */1,
        show: detailsVisible,
        showSidebar: false,
        shadow: true,
        initiator: "pdp-mobile"
      });
    } else {
      return null;
    }
  };
  var match$8 = React.useState(function () {
    return Belt_Option.mapWithDefault(LocalStorage$Showside.get(undefined, "pdpIntro"), true, function (value) {
      return value !== "true";
    });
  });
  var showIntroAnimation = match$8[0];
  React.useEffect(function () {
    if (showIntroAnimation) {
      LocalStorage$Showside.set(undefined, "pdpIntro", "true");
    }
  }, [showIntroAnimation]);
  var slides = React.useMemo(function () {
    return Belt_Array.mapWithIndex(products, function (i, product) {
      var tmp = {
        product: product,
        settings: settings,
        productPosition: i + 1 | 0,
        productsCount: productsCount,
        productCategory: productCategory,
        scrollToDetails: scrollToDetails,
        selectedSlide: Caml_obj.equal(product.id, productId),
        visible: !detailsVisible
      };
      var tmp$1 = Caml_obj.equal(product.id, productId) ? variant : undefined;
      if (tmp$1 !== undefined) {
        tmp.selectedVariant = Caml_option.valFromOption(tmp$1);
      }
      return [product.id, React.createElement(PDPContentMobile$ProductSlide, tmp)];
    });
  }, [Belt_Array.joinWith(products, ",", function (p) {
    return p.id;
  }), productId, variant.id, productsCount, productCategory.id, scrollToDetails, detailsVisible]);
  var tmp = {
    windowHeight: windowHeight,
    goToSlide: goToSlide,
    children: slides,
    preventScroll: handlePreventScroll,
    animation: settings.newMobilePDPCube ? /* Cube */1 : /* Slide */0,
    animate: !productChanged,
    showIntroAnimation: showIntroAnimation
  };
  var tmp$1 = match$3[0];
  if (tmp$1 !== undefined) {
    tmp.selectedSlide = Caml_option.valFromOption(tmp$1);
  }
  var tmp$2;
  if (preventScroll) {
    tmp$2 = null;
  } else {
    var tmp$3 = {
      product: product,
      variant: variant,
      settings: settings,
      isInsideQuickView: isInsideQuickView,
      productCategory: productCategory,
      shouldForceMobile: shouldForceMobile,
      viewport: viewport,
      scrollableContainerRef: scrollableContainerRef,
      scrollToRef: scrollToRef,
      scrollToDetails: scrollToDetails,
      scrollPosition: match$6[0],
      windowHeight: windowHeight,
      products: products,
      onProductClick: onProductClick,
      quantity: quantity,
      setQuantity: setQuantity
    };
    if (showMoreProducts !== undefined) {
      tmp$3.showMoreProducts = Caml_option.valFromOption(showMoreProducts);
    }
    tmp$2 = React.createElement("div", {
      ref: ReactDOMUtils$Showside.Ref.domRef(productDetailsContainerRef),
      className: CSS$Showside.prefix("relative smartnav-pdp__details")
    }, React.createElement(PDPContentMobile$ProductDetails, tmp$3));
  }
  return React.createElement(React.Fragment, undefined, React.createElement(Scrollable$Showside.make, {
    restorationId: "pdp",
    scrollToRef: scrollToRef,
    onScroll: handleScroll,
    children: null,
    fwdRef: scrollableContainerRef,
    className: CSS$Showside.prefix(Cn.make(["h-full bg-main text-primary", preventScroll ? "overflow-hidden" : "overflow-y-auto", showIntroAnimation ? "animate-nudge-up" : ""])),
    onTouchStart: handleTouchStart,
    onTouchEnd: handleTouchEnd
  }, React.createElement(PDPContentMobile$Slider, tmp), tmp$2), renderMobileNavbar(undefined));
}
PDPContentMobile.displayName = "PDPContentMobile";
var make = PDPContentMobile;
export { ColorVariants, ProductSlide, ProductDetails, useCategoryProducts, useProductPosition, Slider, make };
/* react Not a pure module */